import script from "./SupportShow.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportShow.vue?vue&type=script&setup=true&lang=js"

import "./SupportShow.vue?vue&type=style&index=0&id=f1e29530&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1e29530"]])

export default __exports__